import React, { useEffect } from 'react';
import { Card, Typography, Row, Col, Button, Divider, Space, message } from 'antd';
import { EnvironmentOutlined, CalendarOutlined, FileTextOutlined, LikeOutlined, TagsOutlined } from '@ant-design/icons';
import { formatString } from '../Common/ColorCode';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import ClinicMap from './ClinicMap';
import { filterByNonGpProductId } from '../Common/CommonFunction';
function formatPrice(value) {
  return Number(value).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
const { Title, Text } = Typography;
let tempData = {
  product: 'General GP consultation',
  data: [
    {
      key: 'Duration',
      data: '15 minutes'
    },
    {
      key: 'Language',
      data: 'Arabic'
    },
    {
      key: 'Gender',
      data: 'Male'
    },
  ],
  date: '14 January, 2025',
  time: '10:30',
  name: "Oxford Street",
  address: "6 Newburgh Street, Carnaby, London, W1F 7RQ",
}

const BookingConfirmation = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  // console.log('::::::BookingConfirmation:::::', props)
  const navigate = useNavigate();
  let tempDataForDuration = []
  if (props.showAppoinmentData && props.showAppoinmentData?.duration) {
    tempDataForDuration.push({
      key: 'Duration',
      data: props.data && props.data.durationObjectById && props.showAppoinmentData.duration && props.data.durationObjectById[props.showAppoinmentData.duration] ? props.data.durationObjectById[props.showAppoinmentData.duration].duration + ' minutes' : '15 minutes'
    })
  }
  const _bcCat  = props.showAppoinmentData?.clinic?.productCategory;
  const _bcProd = props.showAppoinmentData?.selectedProduct;
  const _bcIsGp = _bcCat?.type === 'gp' || _bcCat?.product_category_id == 1;
  const _bcIsReshedula = props.showAppoinmentData?.clinic?.isReshedula;
  const _bcAllowLang   = _bcIsGp || _bcIsReshedula || _bcProd?.allow_language_selection || _bcCat?.allow_language_selection;
  const _bcAllowGender = _bcIsGp || _bcIsReshedula || _bcProd?.allow_gender_selection   || _bcCat?.allow_gender_selection;

  if (_bcAllowLang && props.showAppoinmentData && props.showAppoinmentData?.language) {
    let data = ''
    if (props.showAppoinmentData.language && props.showAppoinmentData.language.value) {
      data = String(props.showAppoinmentData.language.value)
    } else {
      data = String(props.showAppoinmentData.language)
    }
    let languageName = props.data.languageData.find(landata => String(landata.value) === data)
    const _bcLangLabel = languageName ? languageName.label : data;
    // English is the default — no need to display it in the summary
    if (_bcLangLabel && String(_bcLangLabel).toLowerCase() !== 'english') {
      tempDataForDuration.push({
        key: 'Language',
        data: _bcLangLabel
      })
    }
  }
  // Gender: prefer the updated value set by callbackRescheduleBookingForm (showAppoinmentData.gender),
  // then fall back to the original appointment's preferred_gender.
  const isReshedula = props.showAppoinmentData?.clinic?.isReshedula ||
    (props.showAppoinmentData?.isUpdate && props.showAppoinmentData?.data);
  const effectiveGender = isReshedula
    ? (props.showAppoinmentData?.gender ?? props.showAppoinmentData?.data?.preferred_gender)
    : props.showAppoinmentData?.gender;
  if (_bcAllowGender && effectiveGender && effectiveGender !== 'no_preference') {
    tempDataForDuration.push({
      key: 'Gender',
      data: formatString(effectiveGender)
    })
  }
  // Price chip — shown after Duration with a label
  {
    const _bcSlotInfo = props.showAppoinmentData?.slot?.info;
    const _bcHasAdditional = !!_bcSlotInfo?.additional_charges;
    const _bcSlotPrice = _bcSlotInfo?.price;
    const _bcNormalPrice = _bcSlotInfo?.normal_price;
    const _bcSpecialBand = _bcSlotInfo?.special_pricing_band;
    const _bcDisplayPrice = props.showAppoinmentData?.isUpdate && props.showAppoinmentData?.data?.charges
      ? Math.max(parseFloat(props.showAppoinmentData.data.charges) || 0, parseFloat(_bcSlotPrice) || 0)
      : _bcSlotPrice;
    const _bcSpecialPrice = parseFloat(_bcSpecialBand?.special_price ?? _bcDisplayPrice);
    const _bcHasRealDiscount = !!_bcSpecialBand
      && Number.isFinite(_bcSpecialPrice)
      && Number.isFinite(parseFloat(_bcNormalPrice))
      && _bcSpecialPrice < parseFloat(_bcNormalPrice)
      && !props.showAppoinmentData?.isUpdate;
    if (!_bcHasAdditional && _bcDisplayPrice) {
      tempDataForDuration.push({
        key: 'Price',
        data: _bcHasRealDiscount ? (
          <span style={{ display: 'inline-flex', gap: '4px', alignItems: 'center' }}>
            <span style={{ textDecoration: 'line-through', opacity: 0.7, color: '#000', fontSize: '12px' }}>
              £{formatPrice(_bcNormalPrice)}
            </span>
            <span>£{formatPrice(_bcSpecialBand.special_price ?? _bcDisplayPrice)}</span>
          </span>
        ) : (
          `£${formatPrice(_bcDisplayPrice)}`
        ),
      });
    }
  }
  const openMap = () => {
    let lat = 55.120204, lng = '-3.3682784'
    if (props.showAppoinmentData.slot.clinicData && props.showAppoinmentData.slot.clinicData.latitude && props.showAppoinmentData.slot.clinicData.longitude) {
      lat = props.showAppoinmentData.slot.clinicData.latitude
      lng = props.showAppoinmentData.slot.clinicData.longitude
    }
    if (lng == '') {
      messageApi.error({
        type: 'error',
        content: 'Longitude not found.',
      });
    }
    if (lat == '') {
      messageApi.error({
        type: 'error',
        content: 'Latitude not found.',
      });
    }
    const url = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(url, '_blank');
  }
  const openGoogleCalendarEvent = ({ title, details, location, startDateTime, endDateTime }) => {
    const url = new URL('https://www.google.com/calendar/render');
    url.searchParams.set('action', 'TEMPLATE');
    url.searchParams.set('text', title);
    url.searchParams.set('details', details);
    url.searchParams.set('location', location);
    url.searchParams.set('dates', `${formatForCalendar(startDateTime)}/${formatForCalendar(endDateTime)}`);
    window.open(url.toString(), '_blank');
  }

  function formatForCalendar(date) {
    return moment(date).utc().format('YYYYMMDDTHHmmss') + 'Z';
  }
  const addAppointmentOnGoogleCalender = () => {
    // console.log(':::::::addAppointmentOnGoogleCalender:::::',props.data)
    props.hideConfirm()
    // navigate('/clinic-calendar-page',{ state:{...props.data} })
    // return
    let payload = {}
    if (props.data?.clinic?.address && props?.showAppoinmentData?.confirm?.start_time && props?.showAppoinmentData?.confirm?.end_time && props?.showAppoinmentData?.confirm?.notes && props?.showAppoinmentData?.confirm.patient) {

      payload = {
        title: `${props?.showAppoinmentData?.confirm.patient.first_name} ${props?.showAppoinmentData?.confirm.patient.last_name}`,
        details: `${props?.showAppoinmentData?.confirm.notes}`,
        location: props.data?.clinic?.address ?? '123 Clinic St, Springfield',
        startDateTime: props?.showAppoinmentData?.confirm?.start_time ? calendarDate(props?.showAppoinmentData?.confirm?.start_time) : calendarDate('2025-05-15T09:00:00'),
        endDateTime: props?.showAppoinmentData?.confirm?.end_time ? calendarDate(props?.showAppoinmentData?.confirm?.end_time) : calendarDate('2025-05-15T09:30:00')
      }
    }
    // console.log('payload :::',payload)
    openGoogleCalendarEvent(payload)
  }
  const calendarDate = (input) => {
    return moment(input, "YYYY-MM-DD HH:mm").startOf('hour').format("YYYY-MM-DDTHH:mm:ss");
  }
  // Add logic to calculate and display discount and paid amount
  const calculateDiscount = () => {
    let price = props.showAppoinmentData?.slot?.info?.price || 0;
    
    // For reschedule appointments, use the higher price
    if (props.showAppoinmentData?.isUpdate && props.showAppoinmentData?.data?.charges) {
      price = Math.max(
        parseFloat(props.showAppoinmentData?.data?.charges) || 0,
        parseFloat(props.showAppoinmentData?.slot?.info?.price) || 0
      );
    }
    
    const discount = props?.discount || 0;
    return {
      price,
      discount,
      paidAmount: price - discount,
    };
  };

  const { price, discount, paidAmount } = calculateDiscount();
  // slot.info.price/.normal_price are already normalised (price = amount charged,
  // i.e. the special price when a band applies; normal_price = original amount) —
  // see the same pattern used in ClinicCalendarPage.js's Payment details block.
  const specialBand = props.showAppoinmentData?.slot?.info?.special_pricing_band;
  const normalPrice = props.showAppoinmentData?.slot?.info?.normal_price;
  const hasSpecialBand = !!(specialBand && normalPrice)
    && !props.showAppoinmentData?.isUpdate
    && Number.isFinite(parseFloat(price))
    && Number.isFinite(parseFloat(normalPrice))
    && parseFloat(price) < parseFloat(normalPrice);
  const bandSaving = hasSpecialBand ? (parseFloat(normalPrice) - parseFloat(price)) : 0;
  const totalSaving = bandSaving + (discount > 0 ? parseFloat(discount) : 0);

  return (
    <div style={{ width: 600, margin: '0 auto', background: '#fff', paddingTop: '40px' }}>
      {contextHolder}
      <div style={{ maxWidth: 605, background: "#00838540", padding: 10, marginTop: 20 }}>
                <Title style={{ margin: 0, fontSize: 20, color: '#008385',fontWeight:"400" }}>
                    {/* {capitalizeWords('My booking')}: */}
                    My booking:
                </Title>
            </div>

      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <div style={{ width: '410px', background: "#F0FAFA", padding: 10, marginTop: 40, border: '1px solid #008385' }}>
          {/* Category name */}
          <span style={{ margin: 0, fontSize: 14, color: '#008385', display: 'block' }}>
            {props?.showAppoinmentData?.clinic?.productCategory?.name || ''}
          </span>

          {/* Product name + price — one clean line */}
          {(() => {
            const cat = props?.showAppoinmentData?.clinic?.productCategory;
            const catId = cat?.product_category_id;
            let productName = '';

            if (catId == 2 && props.getAllHealthScreenData?.getAllHealthScreenData?.data) {
              const matched = filterByNonGpProductId(
                props.getAllHealthScreenData.getAllHealthScreenData.data,
                props?.showAppoinmentData?.clinic?.non_gp_product_id
              );
              productName = matched?.[0]?.name || '';
            } else if (catId == 3) {
              const matched = filterByNonGpProductId(
                props?.showAppoinmentData?.clinic?.selectedCorporate?.corporate_products,
                props?.showAppoinmentData?.clinic?.non_gp_product_id
              );
              productName = matched?.[0]?.name || '';
            } else if (cat?.type === 'd2c' || (catId && catId != 1)) {
              // D2C / Women Health / other non-GP: use productData.name or selectedProduct.name
              productName = props?.showAppoinmentData?.clinic?.productData?.name
                || props?.showAppoinmentData?.selectedProduct?.name
                || '';
            }

            if (!productName) return null;

            return (
              <span style={{ margin: 0, fontSize: 14, color: '#008385', display: 'block' }}>
                {productName}
              </span>
            );
          })()}

          {/* Duration / Language / Gender — each on its own row */}
          {(() => {
            const catType = props?.showAppoinmentData?.clinic?.productCategory?.type;
            const visibleChips = tempDataForDuration.filter(rs => {
              if (rs.key === 'Gender' && rs.data.toLowerCase() === 'no preference') return false;
              return true;
            });
            if (!visibleChips.length) return null;
            return (
              <div style={{ fontSize: 13, display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '0 4px' }}>
                {visibleChips.map((rs, i) => (
                  <React.Fragment key={rs.key ?? i}>
                    <span style={{ color: '#000' }}>{rs.key}:&nbsp;<span style={{ color: '#008385', fontWeight: 500 }}>{rs.data}</span></span>
                    {i !== visibleChips.length - 1 && <span style={{ color: '#000', margin: '0 6px' }}>|</span>}
                  </React.Fragment>
                ))}
              </div>
            );
          })()}
        </div>
        <div style={{ width: '410px', background: "#F0FAFA", padding: '15px', border: '1px solid #008385', borderTop: 'none' }}>
          <span style={{ margin: 0, fontSize: 20, color: '#000' }}>{props.showAppoinmentData.slot?.date ? moment(props.showAppoinmentData.slot?.info?.date_select || props.showAppoinmentData.slot?.date).format("D MMMM, YYYY") : tempData.date} | {props.showAppoinmentData.slot.info.start_time ? props.showAppoinmentData.slot.info.start_time : tempData.time}</span>
        </div>
        {(discount > 0 || hasSpecialBand) ? (
      <div style={{ width: '410px', background: "#F0FAFA", padding: '10px', border: '1px solid #008385',borderTop: 'none' }}>
      <div >
        {hasSpecialBand && (
          <div style={{ marginBottom: 8 }}>
            <span style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 5,
              background: specialBand.colour || "#E85D04",
              color: "#fff",
              borderRadius: 20,
              padding: "3px 10px",
              fontSize: 12,
              fontWeight: 600,
            }}>
              <TagsOutlined style={{ color: "#fff" }} /> {specialBand.band_name}
            </span>
          </div>
        )}
        {hasSpecialBand ? (
          <>
            <Row>
              <Col span={12} style={{ textAlign: 'left' }}>
                <Text strong>Original Price:</Text>
              </Col>
              <Col span={12} style={{ textAlign: 'right' }}>
                <Text style={{ color: '#999', textDecoration: 'line-through' }}>£{formatPrice(normalPrice)}</Text>
              </Col>
            </Row>
            <Row>
              <Col span={12} style={{ textAlign: 'left' }}>
                <Text strong>Discounted Price:</Text>
              </Col>
              <Col span={12} style={{ textAlign: 'right' }}>
                <Text style={{ color: specialBand.colour || '#E85D04', fontWeight: 600 }}>£{formatPrice(price)}</Text>
              </Col>
            </Row>
          </>
        ) : (
          <Row>
            <Col span={12} style={{ textAlign: 'left' }}>
              <Text strong>Price:</Text>
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Text>£{formatPrice(price)}</Text>
            </Col>
          </Row>
        )}
        {discount > 0 && (
          <Row>
            <Col span={12} style={{ textAlign: 'left' }}>
              <Text strong>Discount:</Text>
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Text>£{formatPrice(discount)}</Text>
            </Col>
          </Row>
        )}
        {hasSpecialBand && (
          <Row>
            <Col span={12} style={{ textAlign: 'left' }}>
              <Text strong style={{ color: '#008385' }}>You Save:</Text>
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Text style={{ color: '#008385', fontWeight: 500 }}>£{formatPrice(totalSaving)}</Text>
            </Col>
          </Row>
        )}
        <hr></hr>
        <Row>
          <Col span={12} style={{ textAlign: 'left' }}>
            <Text strong>Amount paid:</Text>
          </Col>
          <Col span={12} style={{ textAlign: 'right' }}>
            <Text>£{formatPrice(paidAmount)}</Text>
          </Col>
        </Row>
      </div>
          </div>
        ):''}
        <div style={{ width: '410px', display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
          <div className='remove-map-text' style={{ width: 90, height: 90, borderRadius: "10px", marginLeft: 1 }}>
            {/* <iframe
              width={76}
              height={76}
              style={{ border: "0", marginTop: 0 }}
              loading="lazy"
             src={`https://www.openstreetmap.org/export/embed.html?bbox=${props.showAppoinmentData?.slot?.clinicData?.longitude},${props.showAppoinmentData?.slot?.clinicData?.latitude},${props.showAppoinmentData?.slot?.clinicData?.longitude},${props.showAppoinmentData?.slot?.clinicData?.latitude}&layer=mapnik`}
            ></iframe> */}
            <ClinicMap widthAndheight={{ width: 76, height: 76, }} passData={{
              cood: [{
                id: props.showAppoinmentData?.slot?.clinicData?.id,
                name: props.showAppoinmentData?.slot?.clinicData?.name,
                data: [props.showAppoinmentData?.slot?.clinicData?.latitude, props.showAppoinmentData?.slot?.clinicData?.longitude]
              }]
            }} />
          </div>
          <div style={{ textAlign: 'left', marginLeft: 30 }}>
            <p style={{ fontSize: 14 }}>{props.showAppoinmentData?.slot?.clinicData?.name ? props.showAppoinmentData.slot.clinicData.name : ''}</p>
            <p style={{ fontSize: 14 }}>{props.showAppoinmentData?.slot?.clinicData?.address ? props.showAppoinmentData?.slot?.clinicData?.address : ''}</p>
          </div>
        </div>
      </div>
      <div style={{ width: 410, margin: '0 auto', textAlign: 'center', marginBottom: 20 }}>
        <div style={{
          width: 100, height: 100, borderRadius: '50%', backgroundColor: '#d4eceb',
          display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto'
        }}>
          <LikeOutlined style={{ fontSize: 40, color: '#007070' }} />
        </div>
        <Title level={3} style={{ marginTop: 16 }}>Thank You!</Title>
        <Text>Your Booking Is Successful.</Text><br />
        <Text type="secondary">You should receive a confirmation email from us.</Text>
      </div>
         
      <div style={{
        margin: '0 auto',
        backgroundColor: '#00838540',
        height: 29,
        marginBottom: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <span>Please check how to reach the clinic on time.</span>
      </div>

   

    </div>
  );
};

export default BookingConfirmation;
